
//Azure DEV End Point
import {env} from '../utils/appMode';
let envFlag = env == 'Test'?1:2;

var gateways = {};
if (envFlag == 2) {
    // for DEV environment
    gateways = {
 baseURL : "https://tpt-apim-cargo-dev.azure-api.net/cc-user-management/v1/", 
  utilityBaseURL : "https://tpt-apim-cargo-dev.azure-api.net/utilitymanagement/v1/",
  workFlowBaseURL : "https://tpt-apim-cargo-dev.azure-api.net/v1/",
  trackingBaseURL : 'https://tpt-apim-cargo-dev.azure-api.net/cc-tracking-management/v1/',
 serviceBaseURL : 'https://tpt-apim-cargo-dev.azure-api.net/service-delivery/v1/',
 servicecatalogBaseURL : "https://tpt-apim-cargo-dev.azure-api.net/service-delivery/v1/",
 imagePath:  "https://tpt-apim-cargo-dev.azure-api.net/utilitymanagement/v1/download/advertisementImage?documentPath=",
 invalidTokenPath : 'https://tpt-apim-cargo-dev.azure-api.net/cc-user-management/v1/Invalidationoftokens',
 logoutPath: 'https://tpt-apim-cargo-dev.azure-api.net/ccLogin/v1/ccLogout?post_logout_redirect_uri=https://www.dev-cargoconnect.transnetportterminals.net/',
 fetchTokenPath : 'https://tpt-apim-cargo-dev.azure-api.net/ccLogin/v1/',
 redirectURIPath : 'https://www.dev-cargoconnect.transnetportterminals.net',
    }
}
else if (envFlag == 1) {
    // for TEST environment
    gateways = {
         baseURL : "https://tpt-apim-cargo-test.azure-api.net/cc-user-management/v1/",
  utilityBaseURL : "https://tpt-apim-cargo-test.azure-api.net/utilitymanagement/v1/",
  workFlowBaseURL : "https://tpt-apim-cargo-test.azure-api.net/v1/",
  trackingBaseURL : 'https://tpt-apim-cargo-test.azure-api.net/cc-tracking-management/v1/',
 serviceBaseURL : 'https://tpt-apim-cargo-test.azure-api.net/service-delivery/v1/',
 servicecatalogBaseURL : "https://tpt-apim-cargo-test.azure-api.net/service-delivery/v1/",
 imagePath : "https://tpt-apim-cargo-test.azure-api.net/utilitymanagement/v1/download/advertisementImage?documentPath=",
 invalidTokenPath : "https://tpt-apim-cargo-test.azure-api.net/cc-user-management/v1/Invalidationoftokens",
 logoutPath : 'https://tpt-apim-cargo-test.azure-api.net/ccLogin/v1/ccLogout?post_logout_redirect_uri=https://www.test-cargoconnect.transnetportterminals.net/',
 fetchTokenPath : 'https://tpt-apim-cargo-test.azure-api.net/ccLogin/v1/',
 redirectURIPath : 'https://www.test-cargoconnect.transnetportterminals.net',
    }
}

export const {baseURL,utilityBaseURL,workFlowBaseURL,trackingBaseURL,serviceBaseURL,servicecatalogBaseURL,
    imagePath,invalidTokenPath,logoutPath,fetchTokenPath,redirectURIPath} = gateways;



//  baseURL = "http://102.133.140.19:8080/tpt/cargoconnect/";  
//  utilityBaseURL = "http://102.133.138.144:8082/tpt/cargoconnect/";  
//  workFlowBaseURL = "http://102.133.132.160:8083/tpt/cargoconnect/"; 
//TPT End Point
//  baseURL = "http://10.67.178.51:8080/tpt/cargoconnect/";    
//   utilityBaseURL = "http://10.67.178.51:8082/tpt/cargoconnect/";  
//   workFlowBaseURL = "http://10.67.178.51:8083/tpt/cargoconnect/";